import { useState } from "react";
import { useParams } from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import TableBody from "@material-ui/core/TableBody";
import AddCircle from "@material-ui/icons/AddCircle";
import UserTableActions from "./components/table-action";
import { cpfMask } from "../../../../../../../utils/cpfFormat";
import SearchField from "../../../../../components/search-field";
import { useAttendanceLocalUserList } from "../../../../../../../services/api-tansquery/attendance-local/user/list";
import { useAttendanceLocalStyles } from "../../../../../styles";
import { useUserListTabPanelStyles } from "./styles";
import NewUser from "./components/new-user";
import EmptyState from "../../../../../../../Components/EmptyState";
import CustomPagination from "../../../../../../../Components/pagination";

export default function UserListTabPanel() {
    const [openModal, setOpenModal] = useState<boolean>(false);
    const { slug } = useParams<{ slug: string }>();
    const { classes } = useUserListTabPanelStyles();
    const { classes: defaultClasses } = useAttendanceLocalStyles();
    const { data: users } = useAttendanceLocalUserList({
        unidade: slug,
        order_by: "-created_at",
    });

    const handleAddUser = () => {
        setOpenModal(true);
    };

    const isEmptyUsers = (users?.results ?? []).length === 0;

    return (
        <>
            <Paper elevation={3}>
                <Box className={classes.header}>
                    <Box className={classes.search}>
                        <SearchField placeholder="Buscar usuário" />
                    </Box>
                    <Button
                        onClick={handleAddUser}
                        startIcon={<AddCircle />}
                        className={defaultClasses.addButton}
                    >
                        Usuário
                    </Button>
                </Box>
                <TableContainer className={defaultClasses.tableContainer}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                <TableCell className={defaultClasses.tableTH}>CPF</TableCell>
                                <TableCell className={defaultClasses.tableTH}>Nome</TableCell>
                                <TableCell className={defaultClasses.tableTH}>
                                    Setor Atual
                                </TableCell>
                                <TableCell className={defaultClasses.tableTH} />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {users?.results.map((user) => (
                                <TableRow
                                    hover
                                    key={`user-${user.id}`}
                                    role="checkbox"
                                    tabIndex={-1}
                                >
                                    <TableCell className={defaultClasses.tableCell}>
                                        {cpfMask(user.cpf)}
                                    </TableCell>
                                    <TableCell className={defaultClasses.tableCell}>
                                        {user.nome_completo}
                                    </TableCell>
                                    <TableCell className={defaultClasses.tableCell}>
                                        {user?.misto ? "Misto" : user.setor?.nome}
                                    </TableCell>
                                    <TableCell align="right" className={defaultClasses.tableCell}>
                                        <UserTableActions item={user?.nome_completo} id={user.id} />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    {isEmptyUsers && <EmptyState message="Nenhum usuário encontrado" />}
                </TableContainer>
                <Box className={defaultClasses.paginationContainer}>
                    <CustomPagination
                        count={users?.count}
                        page={users?.current}
                        totalPages={users?.total_pages}
                    />
                </Box>
            </Paper>
            <NewUser
                open={openModal}
                existingUsers={users?.results ?? []}
                handleCloser={() => setOpenModal(false)}
            />
        </>
    );
}
